// extracted by mini-css-extract-plugin
export var icon = "_c0-3";
export var subtitle = "_c0-2";
export var title = "_c0-1";
export var value = "_c0-0";